import { buildUser } from '../../users/helpers/users';
import { getDifferenceDate } from '../../shared/helpers/time';
import groupBy from 'lodash/groupBy';
import moment from 'moment';

export const buildHistories = (histories, statuses = []) => {
    return buildGroup(histories, statuses);
};

const buildGroup = (histories, statuses) => {
    const gropHistoriesByDate = groupBy(histories, h => {
        return moment(new Date(h.date)).format('MM-DD-YYYY');
    });
    const grouped = [];
    Object.keys(gropHistoriesByDate).forEach(g => {
        grouped.push({
            displayDate: buildDisplayDate(g),
            histories: gropHistoriesByDate[g]
                .map(history => buildHistory(history, statuses))
                .filter(history => history.modification.length > 0)
        });
    });
    return grouped;
};

const buildDisplayDate = date => {
    const today = moment().format('MM-DD-YYYY');
    const yesterday = moment()
        .subtract({ days: 1 })
        .format('MM-DD-YYYY');

    if (today === date) {
        return '[TODAY]';
    } else if (yesterday === date) {
        return '[YESTERDAY]';
    } else {
        return moment(new Date(date)).format('DD MMMM YYYY');
    }
};

export const buildHistory = (history, statuses = []) => ({
    ...history,
    // Fallback al username cuando user.data no resuelve (usuarios de manager/integraciones sin User en el CRM)
    user:
        buildUser(history.user.data) ||
        (history.user && history.user.username
            ? { name: history.user.username, lastName: '' }
            : null),
    displayDate: getDifferenceDate(history.date),
    displayTime: moment(history.date).format('HH:mm'),
    modification: history.modification
        .filter(m => ['status', 'project', 'subject', 'assigned', 'comment'].includes(m.field))
        .map(m => {
            switch (m.field) {
                case 'status': {
                    return {
                        ...m,
                        ...statuses.find(status => status._id === m.valueId)
                    };
                }
                default:
                    return m;
            }
        })
});
